import lang from '@/lang'
import { get } from 'lodash'

const langSub = (key, subs) => {
  let str = get(lang, key, '')

  subs.forEach(({ template, subKey, string }) => {
    str = string
      ? str.replace(template, string)
      : str.replace(template, get(lang, subKey, ''))
  })

  return str
}

export default langSub
